import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
    sortby: 'nameItem',
    sortdir: 'ASC',
    s: undefined,
  },
  loading: false,
}

export const productMappingListSlice = createAppSlice({
  name: 'productMappingList',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setLoading: create.reducer((state, { payload }) => {
      state.loading = payload
    }),
  }),
})

export const { setFetchOption, setLoading } = productMappingListSlice.actions

export default productMappingListSlice.reducer
